// extracted by mini-css-extract-plugin
export var wrapper = "Header-module--wrapper--1OVW6";
export var container = "Header-module--container--wcbAe";
export var logoIcon = "Header-module--logoIcon--nrE8u";
export var menuBurgerIcon = "Header-module--menuBurgerIcon--12MKa";
export var menuBurger = "Header-module--menuBurger--wbsNR";
export var close = "Header-module--close--p-+do";